import React from 'react';

export const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.188" height="24.421" viewBox="0 0 19.188 24.421">
    <path id="ic_play_arrow_24px" d="M8 5v24.421L27.188 17.21z" fill="#1592e6" transform="translate(-8 -5)"/>
  </svg>
);
